// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.profile-page {
  padding: 2rem;
  background: #f4f6f8;
  color: #334155;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-auto-rows: min-content; /* Adjust row height to content */
  gap: 1.5rem;
  /* --- NEW RULES START --- */
  /* --- NEW RULES END --- */
}
.profile-page h2 {
  font-size: 1.4rem;
  font-weight: 600;
  color: #004A9A;
  margin-bottom: 2rem;
  text-align: center;
  grid-column: 1/-1;
}
.profile-page .profile-card {
  background: white;
  border-radius: 12px;
  padding: 1.5rem;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  border: 1px solid #e0e0e0;
  margin-bottom: 0;
  /* REMOVED the rule from here */
}
.profile-page .company-info-card {
  grid-row: 1/3; /* Make this card span from row 1 to the start of row 3 */
  grid-column: 2;
}
.profile-page .plan-card {
  grid-column: 1;
  grid-row: 2; /* Place this card on the second row */
}
.profile-page .card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.2rem;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid #f1f1f1;
}
.profile-page .card-header h3 {
  font-size: 1.2rem;
  font-weight: 600;
  color: #004A9A;
  margin: 0;
}
.profile-page .card-header .edit-btn {
  background-color: #004A9A;
  color: white;
  padding: 0.5rem 1rem;
  border: none;
  border-radius: 6px;
  font-size: 0.85rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}
.profile-page .card-header .edit-btn:hover {
  background: #003a7a;
  transform: translateY(-1px);
}
.profile-page .form-row {
  margin-bottom: 1rem;
  display: flex;
  align-items: center;
  gap: 1rem;
}
.profile-page .form-row label {
  font-weight: 500;
  color: #475569;
  font-size: 0.95rem;
  min-width: 120px;
  flex-shrink: 0;
}
.profile-page .form-row input,
.profile-page .form-row select {
  padding: 0.75rem;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  font-size: 0.95rem;
  background: #f9fafb;
  flex: 1 1;
  transition: all 0.3s ease;
}
.profile-page .form-row input:focus,
.profile-page .form-row select:focus {
  outline: none;
  border-color: #3a86ff;
  box-shadow: 0 0 0 3px rgba(58, 134, 255, 0.1);
}
.profile-page .form-row input::placeholder,
.profile-page .form-row select::placeholder {
  color: #94a3b8;
}
.profile-page .form-row p {
  padding: 0.75rem;
  background-color: #f9fafb;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  font-size: 0.95rem;
  color: #475569;
  margin: 0;
  flex: 1 1;
  word-break: break-word;
  overflow-wrap: break-word;
  min-height: 2.5rem;
}
.profile-page .form-row p:empty::before {
  content: "—";
  color: #94a3b8;
}
.profile-page .settings-section {
  margin-bottom: 1.5rem;
}
.profile-page .settings-section:last-of-type {
  margin-bottom: 0;
}
.profile-page .settings-section .section-title {
  font-size: 1rem;
  font-weight: 600;
  color: #475569;
  margin-bottom: 1rem;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid #f1f1f1;
}
.profile-page .form-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  gap: 1rem;
}
.profile-page .plan-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1rem;
}
.profile-page .form-group {
  margin-bottom: 1rem;
}
.profile-page .form-group label {
  display: block;
  font-weight: 500;
  color: #475569;
  padding-bottom: 0.5rem;
  font-size: 0.95rem;
}
.profile-page .form-group input,
.profile-page .form-group textarea,
.profile-page .form-group select {
  width: 100%;
  padding: 0.75rem;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  font-size: 0.95rem;
  background: #f9fafb;
  transition: all 0.3s ease;
  box-sizing: border-box;
}
.profile-page .form-group input:focus,
.profile-page .form-group textarea:focus,
.profile-page .form-group select:focus {
  outline: none;
  border-color: #3a86ff;
  box-shadow: 0 0 0 3px rgba(58, 134, 255, 0.1);
}
.profile-page .form-group input::placeholder,
.profile-page .form-group textarea::placeholder,
.profile-page .form-group select::placeholder {
  color: #94a3b8;
}
.profile-page .form-group textarea {
  min-height: 80px;
  resize: vertical;
}
.profile-page .form-group .field-value {
  padding: 0.75rem;
  background: #f9fafb;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  font-size: 0.95rem;
  color: #475569;
  min-height: 2.5rem;
  word-break: break-word;
  overflow-wrap: break-word;
}
.profile-page .form-group .field-value:empty::before {
  content: "—";
  color: #94a3b8;
}
.profile-page .action-buttons {
  margin-top: 1.5rem;
  padding-top: 1rem;
  border-top: 1px solid #f1f1f1;
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
}
.profile-page .save-btn {
  padding: 0.75rem 1.5rem;
  background-color: #004A9A;
  color: white;
  border: none;
  border-radius: 8px;
  font-weight: 500;
  font-size: 0.9rem;
  cursor: pointer;
  transition: all 0.3s ease;
}
.profile-page .save-btn:hover {
  background: #003a7a;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 74, 154, 0.3);
}
@media (max-width: 768px) {
  .profile-page {
    padding: 1rem;
    grid-template-columns: 1fr;
    gap: 1rem;
    /* ADDED rule to reset grid placement on mobile */
  }
  .profile-page .company-info-card, .profile-page .plan-card {
    grid-column: auto;
    grid-row: auto;
  }
  .profile-page .profile-card {
    padding: 1.5rem;
  }
  .profile-page .profile-card .card-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 1rem;
  }
  .profile-page .profile-card .card-header .edit-btn {
    align-self: flex-end;
  }
  .profile-page .profile-card .form-grid {
    grid-template-columns: 1fr;
    gap: 1rem;
  }
  .profile-page .profile-card .plan-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 1rem;
  }
  .profile-page .profile-card .form-row {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.5rem;
  }
  .profile-page .profile-card .form-row label {
    min-width: auto;
    font-weight: 600;
  }
  .profile-page .profile-card .form-row input,
  .profile-page .profile-card .form-row select,
  .profile-page .profile-card .form-row p {
    width: 100%;
    box-sizing: border-box;
  }
  .profile-page .profile-card .action-buttons .save-btn {
    width: 100%;
    padding: 0.875rem;
    font-size: 1rem;
  }
  .profile-page .profile-card .save-btn {
    width: 100%;
    padding: 0.875rem;
    font-size: 1rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/Profile/Profile.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACE,aAAA;EACA,mBAAA;EACA,cAAA;EACA,aAAA;EACA,qCAAA;EACA,2BAAA,EAAA,iCAAA;EACA,WAAA;EAwBA,4BAAA;EAUA,0BAAA;AA9BF;AADE;EACE,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;EACA,iBAAA;AAGJ;AACE;EACE,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,0CAAA;EACA,yBAAA;EACA,gBAAA;EAEA,+BAAA;AAAJ;AAIE;EACE,aAAA,EAAA,yDAAA;EACA,cAAA;AAFJ;AAKE;EACE,cAAA;EACA,WAAA,EAAA,sCAAA;AAHJ;AAQE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,qBAAA;EACA,sBAAA;EACA,gCAAA;AANJ;AASI;EACE,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;AAPN;AAWI;EACE,yBAAA;EACA,YAAA;EACA,oBAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;AATN;AAWM;EACE,mBAAA;EACA,2BAAA;AATR;AAeE;EACE,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;AAbJ;AAgBI;EACE,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;AAdN;AAkBI;;EAEE,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,SAAA;EACA,yBAAA;AAhBN;AAmBM;;EACE,aAAA;EACA,qBAAA;EACA,6CAAA;AAhBR;AAoBM;;EACE,cAAA;AAjBR;AAsBI;EACE,gBAAA;EACA,yBAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,cAAA;EACA,SAAA;EACA,SAAA;EACA,sBAAA;EACA,yBAAA;EACA,kBAAA;AApBN;AAsBM;EACE,YAAA;EACA,cAAA;AApBR;AA0BE;EACE,qBAAA;AAxBJ;AA2BI;EACE,gBAAA;AAzBN;AA6BI;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,sBAAA;EACA,gCAAA;AA3BN;AAgCE;EACE,aAAA;EACA,4DAAA;EACA,SAAA;AA9BJ;AAkCE;EACE,aAAA;EACA,qCAAA;EACA,SAAA;AAhCJ;AAoCE;EACE,mBAAA;AAlCJ;AAoCI;EACE,cAAA;EACA,gBAAA;EACA,cAAA;EACA,sBAAA;EACA,kBAAA;AAlCN;AAqCI;;;EAGE,WAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;AAnCN;AAqCM;;;EACE,aAAA;EACA,qBAAA;EACA,6CAAA;AAjCR;AAoCM;;;EACE,cAAA;AAhCR;AAoCI;EACE,gBAAA;EACA,gBAAA;AAlCN;AAsCI;EACE,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,yBAAA;AApCN;AAsCM;EACE,YAAA;EACA,cAAA;AApCR;AA0CE;EACE,kBAAA;EACA,iBAAA;EACA,6BAAA;EACA,aAAA;EACA,yBAAA;EACA,WAAA;AAxCJ;AA4CE;EACE,uBAAA;EACA,yBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;EACA,yBAAA;AA1CJ;AA4CI;EACE,mBAAA;EACA,2BAAA;EACA,4CAAA;AA1CN;AA+CE;EAvQF;IAwQI,aAAA;IACA,0BAAA;IACA,SAAA;IAEA,iDAAA;EA7CF;EA8CE;IACE,iBAAA;IACA,cAAA;EA5CJ;EAgDE;IACE,eAAA;EA9CJ;EAiDI;IACE,sBAAA;IACA,uBAAA;IACA,SAAA;EA/CN;EAkDM;IACE,oBAAA;EAhDR;EAqDI;IACE,0BAAA;IACA,SAAA;EAnDN;EAuDI;IACE,qCAAA;IACA,SAAA;EArDN;EAyDI;IACE,sBAAA;IACA,uBAAA;IACA,WAAA;EAvDN;EA0DM;IACE,eAAA;IACA,gBAAA;EAxDR;EA4DM;;;IAGE,WAAA;IACA,sBAAA;EA1DR;EAgEM;IACE,WAAA;IACA,iBAAA;IACA,eAAA;EA9DR;EAmEI;IACE,WAAA;IACA,iBAAA;IACA,eAAA;EAjEN;AACF","sourcesContent":["@charset \"UTF-8\";\n.profile-page {\n  padding: 2rem;\n  background: #f4f6f8;\n  color: #334155;\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  grid-auto-rows: min-content; /* Adjust row height to content */\n  gap: 1.5rem;\n  /* --- NEW RULES START --- */\n  /* --- NEW RULES END --- */\n}\n.profile-page h2 {\n  font-size: 1.4rem;\n  font-weight: 600;\n  color: #004A9A;\n  margin-bottom: 2rem;\n  text-align: center;\n  grid-column: 1/-1;\n}\n.profile-page .profile-card {\n  background: white;\n  border-radius: 12px;\n  padding: 1.5rem;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);\n  border: 1px solid #e0e0e0;\n  margin-bottom: 0;\n  /* REMOVED the rule from here */\n}\n.profile-page .company-info-card {\n  grid-row: 1/3; /* Make this card span from row 1 to the start of row 3 */\n  grid-column: 2;\n}\n.profile-page .plan-card {\n  grid-column: 1;\n  grid-row: 2; /* Place this card on the second row */\n}\n.profile-page .card-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 1.2rem;\n  padding-bottom: 0.5rem;\n  border-bottom: 1px solid #f1f1f1;\n}\n.profile-page .card-header h3 {\n  font-size: 1.2rem;\n  font-weight: 600;\n  color: #004A9A;\n  margin: 0;\n}\n.profile-page .card-header .edit-btn {\n  background-color: #004A9A;\n  color: white;\n  padding: 0.5rem 1rem;\n  border: none;\n  border-radius: 6px;\n  font-size: 0.85rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n.profile-page .card-header .edit-btn:hover {\n  background: #003a7a;\n  transform: translateY(-1px);\n}\n.profile-page .form-row {\n  margin-bottom: 1rem;\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n}\n.profile-page .form-row label {\n  font-weight: 500;\n  color: #475569;\n  font-size: 0.95rem;\n  min-width: 120px;\n  flex-shrink: 0;\n}\n.profile-page .form-row input,\n.profile-page .form-row select {\n  padding: 0.75rem;\n  border: 1px solid #e0e0e0;\n  border-radius: 8px;\n  font-size: 0.95rem;\n  background: #f9fafb;\n  flex: 1;\n  transition: all 0.3s ease;\n}\n.profile-page .form-row input:focus,\n.profile-page .form-row select:focus {\n  outline: none;\n  border-color: #3a86ff;\n  box-shadow: 0 0 0 3px rgba(58, 134, 255, 0.1);\n}\n.profile-page .form-row input::placeholder,\n.profile-page .form-row select::placeholder {\n  color: #94a3b8;\n}\n.profile-page .form-row p {\n  padding: 0.75rem;\n  background-color: #f9fafb;\n  border: 1px solid #e0e0e0;\n  border-radius: 8px;\n  font-size: 0.95rem;\n  color: #475569;\n  margin: 0;\n  flex: 1;\n  word-break: break-word;\n  overflow-wrap: break-word;\n  min-height: 2.5rem;\n}\n.profile-page .form-row p:empty::before {\n  content: \"—\";\n  color: #94a3b8;\n}\n.profile-page .settings-section {\n  margin-bottom: 1.5rem;\n}\n.profile-page .settings-section:last-of-type {\n  margin-bottom: 0;\n}\n.profile-page .settings-section .section-title {\n  font-size: 1rem;\n  font-weight: 600;\n  color: #475569;\n  margin-bottom: 1rem;\n  padding-bottom: 0.5rem;\n  border-bottom: 1px solid #f1f1f1;\n}\n.profile-page .form-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));\n  gap: 1rem;\n}\n.profile-page .plan-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 1rem;\n}\n.profile-page .form-group {\n  margin-bottom: 1rem;\n}\n.profile-page .form-group label {\n  display: block;\n  font-weight: 500;\n  color: #475569;\n  padding-bottom: 0.5rem;\n  font-size: 0.95rem;\n}\n.profile-page .form-group input,\n.profile-page .form-group textarea,\n.profile-page .form-group select {\n  width: 100%;\n  padding: 0.75rem;\n  border: 1px solid #e0e0e0;\n  border-radius: 8px;\n  font-size: 0.95rem;\n  background: #f9fafb;\n  transition: all 0.3s ease;\n  box-sizing: border-box;\n}\n.profile-page .form-group input:focus,\n.profile-page .form-group textarea:focus,\n.profile-page .form-group select:focus {\n  outline: none;\n  border-color: #3a86ff;\n  box-shadow: 0 0 0 3px rgba(58, 134, 255, 0.1);\n}\n.profile-page .form-group input::placeholder,\n.profile-page .form-group textarea::placeholder,\n.profile-page .form-group select::placeholder {\n  color: #94a3b8;\n}\n.profile-page .form-group textarea {\n  min-height: 80px;\n  resize: vertical;\n}\n.profile-page .form-group .field-value {\n  padding: 0.75rem;\n  background: #f9fafb;\n  border: 1px solid #e0e0e0;\n  border-radius: 8px;\n  font-size: 0.95rem;\n  color: #475569;\n  min-height: 2.5rem;\n  word-break: break-word;\n  overflow-wrap: break-word;\n}\n.profile-page .form-group .field-value:empty::before {\n  content: \"—\";\n  color: #94a3b8;\n}\n.profile-page .action-buttons {\n  margin-top: 1.5rem;\n  padding-top: 1rem;\n  border-top: 1px solid #f1f1f1;\n  display: flex;\n  justify-content: flex-end;\n  gap: 0.5rem;\n}\n.profile-page .save-btn {\n  padding: 0.75rem 1.5rem;\n  background-color: #004A9A;\n  color: white;\n  border: none;\n  border-radius: 8px;\n  font-weight: 500;\n  font-size: 0.9rem;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n.profile-page .save-btn:hover {\n  background: #003a7a;\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(0, 74, 154, 0.3);\n}\n@media (max-width: 768px) {\n  .profile-page {\n    padding: 1rem;\n    grid-template-columns: 1fr;\n    gap: 1rem;\n    /* ADDED rule to reset grid placement on mobile */\n  }\n  .profile-page .company-info-card, .profile-page .plan-card {\n    grid-column: auto;\n    grid-row: auto;\n  }\n  .profile-page .profile-card {\n    padding: 1.5rem;\n  }\n  .profile-page .profile-card .card-header {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 1rem;\n  }\n  .profile-page .profile-card .card-header .edit-btn {\n    align-self: flex-end;\n  }\n  .profile-page .profile-card .form-grid {\n    grid-template-columns: 1fr;\n    gap: 1rem;\n  }\n  .profile-page .profile-card .plan-grid {\n    grid-template-columns: repeat(2, 1fr);\n    gap: 1rem;\n  }\n  .profile-page .profile-card .form-row {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 0.5rem;\n  }\n  .profile-page .profile-card .form-row label {\n    min-width: auto;\n    font-weight: 600;\n  }\n  .profile-page .profile-card .form-row input,\n  .profile-page .profile-card .form-row select,\n  .profile-page .profile-card .form-row p {\n    width: 100%;\n    box-sizing: border-box;\n  }\n  .profile-page .profile-card .action-buttons .save-btn {\n    width: 100%;\n    padding: 0.875rem;\n    font-size: 1rem;\n  }\n  .profile-page .profile-card .save-btn {\n    width: 100%;\n    padding: 0.875rem;\n    font-size: 1rem;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
